import React from 'react'
import PropTypes from 'prop-types'

import CustomRadio from '../Shared/CustomRadio'

const CampaignGoalRadio = ({ checked, goalTitle, goal, onGoalSelected, disabled }) => {
  return (
    <div
      className={`event-header-goal ${disabled ? 'event-header-goal_disabled' : ''} rounded ${checked ? 'active' : ''}`}
      onClick={() => !disabled && onGoalSelected(goal)}
      title={goalTitle}
    >
      <CustomRadio
        className="event-header-goal"
        checked={checked}
        onChange={() => onGoalSelected(goal)}
        disabled={disabled}
      />
      <p className="title">{goalTitle}</p>
    </div>
  )
}

CampaignGoalRadio.propTypes = {
  disabled: PropTypes.bool.isRequired,
  checked: PropTypes.bool.isRequired,
  goalTitle: PropTypes.string.isRequired,
  goal: PropTypes.string.isRequired,
  onGoalSelected: PropTypes.func.isRequired,
}

export default CampaignGoalRadio
